export const BATTERY_LOW = 3.4;